import { Component, Input, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'fa-test-score-popup',
  templateUrl: './test-score-popup.component.html',
  styleUrls: ['./test-score-popup.component.scss']
})
export class TestScorePopupComponent implements OnInit {
  layout: FormlyFieldConfig[];
  model: any = {};
  dataModel: string;
  testType: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TestScorePopupComponent>
  ) { }

  ngOnInit(): void {
    this.testType = this.data.testType;
    this.layout = this.data.layout;
    this.model = this.data.model;
    this.dataModel = this.data.dataModel;
  }

  dataProcessor(data: any) {
    return data;
  }

  closeModal() {
    this.dialogRef.close();
  }

  // test-score-popup.component.ts
  // In test-score-popup.component.ts
onSubmit(event: any) {
  console.log('Form submit event:', event);
  
  if (event?.error) {
    console.error('Form submission error:', event.error);
  } else {
    // Close the dialog with the updated data
    // Make sure you're passing the right data object here
    this.dialogRef.close(event.data || this.model);
  }
}
}